// extracted by mini-css-extract-plugin
module.exports = {"root":"Projects_root__1oy-H"};